import { mapState, mapGetters,  mapActions } from 'vuex'

// 任意のサービスに属するすべての「画面／サービス・コンテンツ」から画面を選択するUIモジュール
// ●使用箇所
// 「サービス管理-機能設定-警戒レベル告知機能」
export default {
  name: 'ServiceScreenSelectorButton',
  props: {
    name: {
      type: String,
      require: true
    },
    serviceId: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: String,
      require: false,
      'default': () => ''
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    },
    overlay: {
      type:Boolean,
      default: () => false,
    }
  },
  data () {
    return {
      loading: true,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectServiceScreenModal.buttonId,
      modalIndex: state => state.selectServiceScreenModal.index,
      value: state => state.selectServiceScreenModal.value
    }),
    ...mapGetters({
      getScreenName: 'selectServiceScreenModal/getScreenName',
    }),

    screenName () {
      //TODO 画面名を取得
      console.log(this.model)
      return this.getScreenName(this.model)
    },

    showDeleteButton () {
      return this.model ? true : false
    }
  },
  watch: {
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to &&
        this.buttonId === this.name &&
        this.index === this.modalIndex) {
        // console.log(this.name, to)
        this.changeScreen(to)
      }
    }
  },
  methods: {
    ...mapActions({
      showSelectServiceScreenModal: 'selectServiceScreenModal/show',
      loadModel: 'selectServiceScreenModal/loadModel',
    }),

    init () {
      // RSS取得のためデータ読出
      this.loading = true

      //
      let serviceContentsParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        serviceContentsParams: serviceContentsParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    showScreenSelector () {
      this.showSelectServiceScreenModal({
        serviceId: this.serviceId,
        buttonId: this.name,
        index: this.index,
        overlay: this.overlay,
      })
    },

    changeScreen (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    deleteScreen () {
      this.$emit('childs-delete', {
        name: this.name,
        index: this.index
      })
    }
  }
}